<script lang="ts">
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {createEventDispatcher} from "svelte";
    import {AppFilters} from "../../models/app-filters";

    let dispatch = createEventDispatcher();

    export let appFilters: AppFilters;

    let filters = [];
    $: {
        if (appFilters) {
            filters = appFilters.tags;
        }
    }

    function edit() {
        dispatch('edit');
    }

    function removeall() {
        appFilters.clearAll();
        appFilters = appFilters;
        dispatch('change');
    }

    function clear(variable: string) {
        appFilters.clear(variable);
        appFilters = appFilters;
        dispatch('change');
    }
</script>
<section class="py-ii" style="background: #fafafa">
    {#if filters.length}
    <div class="container">
        <div class="box-l sx-ii">
            {#each filters as filter (filter.value)}
                <div class="naui-tag box-l sx-ii"><span>{filter.label}</span>
                    <div class="box" on:click={() => clear(filter.variable)}>
                        <span class="pointer mt-i" style="font-size:16px;">&times;</span>
                    </div>
                </div>
            {/each}
            <NauiButton icon="close" size="small" color="secondary" on:click={removeall}/>
            <NauiButton icon="edit" size="small" color="secondary" on:click={edit} />
        </div>
    </div>
    {/if}
</section>
<style>
    .naui-tag {
        background: #00B1B733;
        color: #027276;
        border:none;
        padding-right:.75rem;
        height: 28px;
    }
    .naui-tag  span{
        color:  #027276;
    }
</style>